import { Helpers } from "../../../helpers/Helpers"
import { GetInvoiceByIdResponseInvoiceDetail } from "../../../models/response/invoice/GetInvoiceByIdResponse"
import { KTCard } from "../../../_metronic/helpers/components/KTCard"
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody"
import Box from "../../Box"

interface Props {
    totalInformationRef: any
    description: string | undefined
    setDescription: React.Dispatch<React.SetStateAction<string | undefined>>
    invoiceDetails: GetInvoiceByIdResponseInvoiceDetail[]
    currency: string | undefined
}

const CommonInvoiceTotalInformation = ({
    totalInformationRef,
    description,
    setDescription,
    invoiceDetails,
    currency
}: Props) => {
    return (
        <div className='containerPart' ref={totalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Toplam Bilgileri</h4>

                    <Box flexDirection="row" gap="20px">
                        <Box flex={1}>
                            <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                            <textarea value={description} onChange={(e) => setDescription(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: '100%', resize: 'none' }} className="form-control form-control-solid" />
                        </Box>

                        <Box flex={1}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Yerel Toplam Tutar</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.totalWithoutTaxPrice) * Helpers.toNumber(currency))))} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Yerel Kdv Tutarı</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.taxPrice) * Helpers.toNumber(currency))))} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Yerel Tevkifat Tutarı</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.withholdingPrice) * Helpers.toNumber(currency))))} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Yerel Brüt Tutar</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.totalPrice) * Helpers.toNumber(currency))))} type="text" className="form-control form-control-solid" disabled />
                            </div>
                        </Box>

                        <Box flex={1}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Toplam Tutar</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.totalWithoutTaxPrice))))} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Kdv Tutarı</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.taxPrice))))} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Tevkifat Tutarı</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.withholdingPrice))))} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Brüt Tutar</label>
                                <input style={{ textAlign: 'right', border: '1px solid #F1F1F4' }} value={Helpers.correctPrice(Helpers.sumOfNumbers(invoiceDetails.map(x => Helpers.toNumber(x.totalPrice))))} type="text" className="form-control form-control-solid" disabled />
                            </div>
                        </Box>
                    </Box>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default CommonInvoiceTotalInformation;